export default __webpack_public_path__ + "static/media/landing2.fad38d0c.png";